import { render, staticRenderFns } from "./WidgetNewInvoices.vue?vue&type=template&id=494938f5"
import script from "./WidgetNewInvoices.vue?vue&type=script&lang=js"
export * from "./WidgetNewInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports